/* eslint-disable prefer-const */
/* eslint-disable no-useless-escape */
/* eslint-disable no-nested-ternary */
/* eslint-disable vars-on-top */
/* eslint-disable no-shadow */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
/* eslint-disable no-var */
import React, { useState } from 'react';
import Card from 'components/Card/Card.jsx';
import Grid from '@material-ui/core/Grid';
import CardBody from 'components/Card/CardBody.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';
import Button from 'components/CustomButtons/Button.jsx';
import Add from '@material-ui/icons/Add';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import uuid from 'react-uuid';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import swal from 'sweetalert';
import { makeStyles } from '@material-ui/core/styles';
import SaveIcon from '@material-ui/icons/Save';
import { CircularProgress, TextField } from '@material-ui/core';
import ListViewContacts from './ListViewContacts';
import firebase from '../../../config/config';
import { mappedCurrentActiveRole } from '../../../utils/roleMapping';
import logger from '../../../utils/logger';
import apiCaller from '../../../utils/apiCallerOutstanding';

const useStyles = makeStyles({
  saveButton: {
    backgroundColor: '#3DAC16',
  },
});
const SecondaryContacts = ({
  classes,
  truckerData,
  activeRole,
  userDetails,
  refetch,
}) => {
  const [formValues, setFormValues] = useState([]);
  const [error, setError] = useState('');
  const [errorName, setErrorName] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const customers = truckerData?.poc_list || [];
  const [role, setRole] = React.useState('trip');
  const [fetching, setFetching] = React.useState(false);
  const [numberDisabled, setNumberDisabled] = React.useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const handleChangeSelect = (index, event) => {
    setRole(event.target.value);
    handleChange(index, event);
  };
  const customClasses = useStyles();
  const { trucker_id: truckerId, blacklist } = truckerData;

  const handleChange = (i, e, type) => {
    let newFormValues = [...formValues];
    if (type === 'number') {
      const validatephoneNumberNumberRegex = /^[6-9][0-9]{9}$/;

      if (
        validatephoneNumberNumberRegex.test(e.target.value) &&
        e.target.value.length === 10
      ) {
        setError('');
        setErrorMessage('');
        if (e.target.value.length === 10) {
          const duplicate = customers.some(
            item => item.phone_number === e.target.value
          );
          if (duplicate) {
            setError(i);
            setErrorMessage('Duplicate Numbers Entered');
          } else {
            setError('');
            setErrorMessage('');
          }
        }
      } else {
        setError(i);
        setErrorMessage('Enter Correct Number');
      }
    } else if (type === 'name') {
      const regexCompany = /^[a-zA-Z0-9 _,.]*$/;
      if (regexCompany.test(e.target.value)) {
        setErrorName('');
        setErrorMessage('');
      } else {
        setErrorName(i);
        setErrorMessage('Please Enter Correct Name');
      }
    }

    newFormValues[i][e.target.name] = e.target.value;
    setFormValues(newFormValues);
  };

  const handleSubmit = async event => {
    event.preventDefault();
    setFetching(true);
    try {
      const currentActiveRole =
        userDetails?.isSalesManager && activeRole === 'sales'
          ? 'isSalesManager'
          : mappedCurrentActiveRole(activeRole);
      const userToken = await firebase.auth().currentUser.getIdToken();

      // Validate phone numbers before calling add API
      if (!isEdit) {
        const validationResults = await Promise.all(
          formValues
            .filter(form => form.phoneNumber)
            .map(async form => {
              const response = await apiCaller(
                `pipe/v1/poc-validate-phone?phone_number=${form.phoneNumber}`,
                {},
                `Bearer ${userToken}`,
                'nh-base',
                'get'
              );
              // Don't continue if validation API returns
              // null, undefined, or invalid response
              if (
                !response?.data ||
                typeof response?.data?.user_exists !== 'boolean'
              ) {
                throw new Error(
                  `Phone validation failed for ${form.phoneNumber}`
                );
              }
              return {
                phoneNumber: form.phoneNumber,
                userExists: response?.data?.user_exists,
              };
            })
        );
        const existingUser = validationResults?.find(item => item.userExists);
        if (existingUser) {
          swal({
            title: 'Cannot Add POC',
            text: `${existingUser.phoneNumber} is linked to an internal user and cannot be added.`,
            icon: 'warning',
          });
          return;
        }
      }
      // Add / update POCs
      await Promise.all(
        formValues.map(form => {
          const body = {
            role: currentActiveRole,
            org_type: 'trucker',
            name: form.name,
            access: form.role,
            ...(isEdit
              ? {
                  poc_id: form.customerId,
                }
              : {
                  org_id: truckerId,
                  phone_number: form.phoneNumber,
                }),
          };
          const endpoint = isEdit
            ? 'pipe/v1/poc-details/update'
            : 'pipe/v1/poc-details/add';
          return apiCaller(
            endpoint,
            body,
            `Bearer ${userToken}`,
            'nh-base',
            'post'
          );
        })
      );
      swal({
        title: 'Success!',
        text: 'Customer POC added successfully.',
        icon: 'success',
        timer: 4000,
      });
      setFormValues([]);
      await refetch();
    } catch (error) {
      logger.error(error);
      swal({
        title: 'Error!',
        text: 'Failed to add Customer POC.',
        icon: 'error',
      });
    } finally {
      setFetching(false);
    }
  };

  const handleAddForm = () => {
    setIsEdit(false);
    setNumberDisabled(false);
    setFormValues([
      ...formValues,
      {
        orgId: truckerId,
        name: '',
        phoneNumber: '',
        role: 'trip',
        userType: 'trucker',
        userActive: true,
        customerId: uuid(),
        createdAt: new Date(),
        modifiedAt: new Date(),
        communicationsEnabled: new Date(),
      },
    ]);
  };
  const handleEditCustomer = customer => {
    setIsEdit(true);
    setNumberDisabled(true);
    setFormValues([
      {
        orgId: truckerId,
        name: customer.poc_name,
        phoneNumber: customer.phone_number,
        role: 'trip',
        userType: 'trucker',
        userActive: true,
        customerId: customer.poc_id,
        createdAt: customer?.created_at
          ? new Date(customer.created_at)
          : new Date(),
        modifiedAt: new Date(),
        ...(customer?.communications_enabled && {
          communicationsEnabled: new Date(customer.communications_enabled),
        }),
      },
    ]);
  };
  return (
    <Card style={{ marginTop: 0, marginBottom: 10 }}>
      <CardHeader style={{ padding: '10px' }}>
        <h4 style={{ margin: 0, fontWeight: 400 }}>Customer POC</h4>
      </CardHeader>
      <CardBody style={{ padding: 0 }}>
        <Grid container>
          {fetching ? (
            <CircularProgress />
          ) : (
            <Grid item xs={12}>
              <ListViewContacts
                customers={
                  blacklist
                    ? customers
                    : customers?.filter(customer => customer?.user_active)
                }
                activeRole={activeRole}
                handleEdit={value => handleEditCustomer(value)}
                refetch={refetch}
                userDetails={userDetails}
                blacklist={blacklist}
              />
            </Grid>
          )}
        </Grid>
        <div style={{ padding: '10px' }}>
          <Grid container direction="column" spacing={2}>
            {formValues.map((element, index) => (
              <Grid item md={12} key={element?.orgId}>
                <Grid
                  container
                  spacing={2}
                  direction="row"
                  alignItems="baseline"
                >
                  <Grid item md={3}>
                    <TextField
                      fullWidth
                      error={errorName === index}
                      size="small"
                      name="name"
                      id="standard-basic"
                      label="Full Name"
                      value={element.name || ''}
                      onChange={e => handleChange(index, e, 'name')}
                      helperText={errorName === index ? errorMessage : ''}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item md={3}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      error={error === index}
                      size="small"
                      name="phoneNumber"
                      disabled={numberDisabled}
                      id="standard-basic"
                      label="Mobile Number"
                      value={element.phoneNumber || ''}
                      onChange={e => handleChange(index, e, 'number')}
                      helperText={error === index ? errorMessage : ''}
                    />
                  </Grid>
                  <Grid item md={2}>
                    <FormControl
                      variant="outlined"
                      className={classes.formControl}
                      size="small"
                    >
                      <InputLabel id="demo-simple-select-outlined-label">
                        Access
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        value={role}
                        onChange={event => handleChangeSelect(index, event)}
                        label="role"
                        name="role"
                        style={{ width: '100%' }}
                      >
                        <MenuItem default value="trip">
                          Trip
                        </MenuItem>
                        <MenuItem value="org">Org</MenuItem>
                        <MenuItem value="owner">Owner</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            ))}
            <Grid item>
              <Grid
                container
                alignItems="center"
                justifyContent="space-between"
              >
                <Grid item>
                  {(activeRole == 'sales' ||
                    activeRole === 'branch-ops' ||
                    activeRole == 'traffic') &&
                  !blacklist ? (
                    <Button
                      color="info"
                      onClick={handleAddForm}
                      className={classes.updateProfileButton}
                      justIcon
                    >
                      <Add />
                    </Button>
                  ) : (
                    ''
                  )}
                </Grid>
                {formValues.length == 0 ? null : (
                  <Grid item>
                    <Button
                      type="submit"
                      autoFocus
                      startIcon={<SaveIcon />}
                      size="small"
                      className={customClasses.saveButton}
                      disabled={
                        formValues.every(
                          item => item.name === '' && item.phoneNumber === ''
                        ) || error !== ''
                      }
                      onClick={handleSubmit}
                    >
                      Save
                    </Button>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
        </div>
      </CardBody>
    </Card>
  );
};

export default SecondaryContacts;
